// extracted by mini-css-extract-plugin
export default {"double-tooltip-container":"DoubleTooltip_double-tooltip-container__r-KOb","tooltip":"DoubleTooltip_tooltip__1hTFn","first-tooltip":"DoubleTooltip_first-tooltip__yl0Ch"};